<template>
  <div class="q_pad_lr15px q_mar_t15px">

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功"  v-if="!showEmpty">
      <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          error-text="请求失败，点击重新加载"
      >
        <div class="q_vertical_left q_mar_b15px" v-for="item in list" :key="item.id" @click="goToJoindea(item.deptId)">
          <div class="q_inlineblock">
            <van-image class="q_join_img" fit="cover" :src="item.pic"/>
          </div>
          <div class="q_mar_l15px q_inlineblock q_con">
            <div class="q_text_m q_bold q_moit2 q_justify">{{ item.deptName }}</div>
            <div class="q_text_s q_color_gray q_mar_t5px q_moit2">{{ item.address }}</div>
            <div class="q_vertical_left q_mar_t30px q_borra">
              <van-image :key="item.id" v-for="user in item.userList" width="5vw" height="5vw" fit="cover" :src="user.avatar"
                         style="margin-right: 1vw;"/>
              <span class="q_text_s q_color_gray" v-if=" item.userList.length">等{{ item.deptUserNumber }}位伙伴</span>
            </div>
          </div>
          <van-button type="primary" size="small" color="#FF5733">加 入</van-button>
        </div>

      </van-list>

    </van-pull-refresh>
    <!--空数据-->
    <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
      <img src="@/assets/image/none.png" style="width: 26vw;"/>
      <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
    </div>
  </div>
</template>

<script>
import {listJoin} from "@/api/join";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Join',
  props: {
    msg: String
  },
  data() {
    return {
      showEmpty: false,
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      pageParam: {
        pageNum: 0,
        pageSize: 5,
      }
    }
  },
  created() {
    wxCloseShare()
  },
  methods: {
    /**
     * 下拉刷新
     */
    onRefresh() {
      this.pageParam = {
        pageNum: 0,
        pageSize: 5,
      }
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    /**
     * 下滑加载更多
     */
    onLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //查询协会信息列表
      listJoin(this.pageParam).then(res => {
        if (res.total == 0) {
          this.showEmpty = true
        }
        //是否下拉刷新
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        for (let i = 0; i < res.rows.length; i++) {
          this.list.push(res.rows[i]);
          // const sliceA=this.list[i].userList.slice(0,3)
          // this.list[i].userList = sliceA
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= res.total) {
          this.finished = true;
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    goToJoindea(id) {
      this.$router.push({
        path: '/home/Joindea', query: {id: id}
      });
    },
  },
}
</script>
<style scoped="scoped">
.q_join_img {
  width: 105px;
  height: 105px;
}

.q_join_img >>> .van-image__img {
  border-radius: 5px;
}

.q_borra >>> .van-image__img {
  border-radius: 50%;
}

.q_con {
  width: 165px;
}

.van-button {
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  border-top-right-radius: 16px;
  width: 60px;
}
</style>
